export const RoutesData = [
  { id: '1', item: "Περίπατος", value: 'walking' },
  { id: '2', item: "Πεζοπορία", value: 'hiking' },
  { id: '3', item: "Εκδρομή", value: 'excursion' }
]